import { createSlice } from "@reduxjs/toolkit";
import { IWorkOrder, createWorkOrder } from "../../../models/workOrder";

interface IWorkORderState {
    workOrder: IWorkOrder,
    isLoading: boolean
}

const initialState: IWorkORderState = {
    workOrder: createWorkOrder({}),
    isLoading: false
}

export const workOrderSlice = createSlice({
    name: 'workOrder',
    initialState,
    reducers: {
        setWorkOrder: (state, action) => {
            state.isLoading = false;
            state.workOrder = action.payload.workOrder;
        },
        startLoadingWorkOrder: (state) => {
            state.isLoading = true;
        },
        stopLoadingWorkOrder: (state) => {
            state.isLoading = false;
        }
    }
})

export const {
    setWorkOrder,
    startLoadingWorkOrder,
    stopLoadingWorkOrder
} = workOrderSlice.actions;